import { render } from "./CustomerItemsChart.vue?vue&type=template&id=1c7f3f10&scoped=true"
import script from "./CustomerItemsChart.vue?vue&type=script&lang=js"
export * from "./CustomerItemsChart.vue?vue&type=script&lang=js"

import "./CustomerItemsChart.vue?vue&type=style&index=0&id=1c7f3f10&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7f3f10"]])

export default __exports__